import {
  Tooltip,
  createTheme,
  ThemeProvider,
  TooltipProps
} from '@mui/material';
import { FC } from 'react';

const theme = createTheme({
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: 'white',
          padding: 0,
          color: 'black'
        }
      }
    }
  }
});

const ThemedTooltip: FC<TooltipProps> = ({
  placement,
  children,
  title,
  open,
  disableHoverListener
}) => {
  return (
    <ThemeProvider theme={theme}>
      <Tooltip
        title={title}
        placement={placement}
        leaveDelay={100}
        open={open}
        disableHoverListener={disableHoverListener}
      >
        {children}
      </Tooltip>
    </ThemeProvider>
  );
};

export default ThemedTooltip;
